import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "body-2 text-grey" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-flex flex-column align-center" }
const _hoisted_6 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_7 = { class: "ml-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(_ctx.text), 1),
      _createVNode(_component_v_menu, {
        modelValue: _ctx.showMenu,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showMenu) = $event)),
        absolute: "",
        "offset-y": "",
        "max-width": "290px"
      }, _createSlots({
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (s, index) => {
                return (_openBlock(), _createBlock(_component_v_list_item, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "d-flex align-center",
                          onClick: ($event: any) => (_ctx.changeStatusItem(s.status))
                        }, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", {
                                class: _normalizeClass(`circle-back-${s.status}`)
                              }, null, 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(`circle-front-${s.status}`)
                              }, null, 2)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(s.title), 1)
                        ], 8, _hoisted_4)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        (_ctx.item)
          ? {
              name: "activator",
              fn: _withCtx(({ props }) => [
                _createElementVNode("div", _mergeProps({ class: "d-flex flex-column align-center ml-5" }, props), [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`circle-back-${_ctx.showMealStatus(_ctx.item)}`)
                    }, null, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(`circle-front-${_ctx.showMealStatus(_ctx.item)}`)
                    }, null, 2)
                  ]),
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.showMealStatusText(_ctx.item)), 1)
                ], 16)
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue"])
    ])
  ]))
}